import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import FormPreview from "./FormPreview";
import Sidebar from "./Sidebar";
const PreviewAndEmbed = () => {
	return (
		<Flex bg="background.primary" align="flex-start" p="1rem" justify="space-between">
			{/* sidebar */}
			<Sidebar />
			{/* form preview */}
			<FormPreview />
		</Flex>
	);
};

export default PreviewAndEmbed;
